<template>
  <div class="layer layer2">
    <div class="inner">
      <button type="button" class="btnClose" @click="close"></button>
      <h2 class="layerTitle">{{locale.page_set_available}}</h2>
      <div class="info">
        <div class="mb15 isRequired">
          <div class="innerTitle setLabel">{{locale.name}}</div>
          <input type="text" class="input" v-model="name">
        </div>
        <div class="isRequired">
          <div class="innerTitle setLabel">{{locale.page_set_available}}</div>
          <SetAvailableTime
            v-if="presetId && presetId !== 'new' ? availableTime : true"
            :locale="locale"
            :availableTime="availableTime"
            @update="getAvailableTime" />
        </div>
      </div>
      <div class="btns">
        <button type="button" class="btn btnWhite" @click="close">{{ locale.cancel }}</button>
        <button type="button" class="btn btnPrimary" :disabled="!isValid" @click="save">{{ locale.save }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import LANG from '@/common/lang'
import UNIQUE from '@/common/unique'
import regExp from '@/common/regExp'
import SetAvailableTime from '@/components/Util/SetAvailableTime'

export default {
  name: 'CompositeAvailableTime',
  props: [
    'locale',
    'presetId'
  ],
  components: {
    SetAvailableTime
  },
  computed: {
    isValid () {
      const name = regExp.replaceAllEmpty(this.name) !== ''
      return name
    }
  },
  created () {
    if (this.presetId && this.presetId !== 'new') {
      this.getShopPresetDetail()
    }
  },
  data () {
    return {
      name: '',
      availableTime: null
    }
  },
  methods: {
    async getShopPresetDetail () {
      this.$store.commit('onLoading', true)
      const getDetail = await this.$store.dispatch('shop/getShopPresetDetail', {
        presetType: 'availableTime',
        presetId: this.presetId
      })
      const detail = getDetail && getDetail.message
      if (detail && detail.presetId) {
        this.name = detail.presetName,
        this.availableTime = detail.presetOptions
      }
      this.$store.commit('onLoading', false)
    },
    close () {
      this.$emit('close')
    },
    getAvailableTime (data) {
      this.availableTime = data
    },
    async save () {
      const presetId = this.presetId && this.presetId !== 'new' && this.presetId
      const data = {
        presetType: 'availableTime',
        presetId: presetId || UNIQUE.uniqueId8(),
        presetName: this.name,
        presetOptions: this.availableTime
      }
      this.$store.commit('onLoading', true)
      const res = await this.$store.dispatch('shop/putShopPreset', data)
      if (res && res.status === 200) {
        alert(this.locale.complete_save)
        this.$emit('reload', data.presetId)
        this.close()
      }
      this.$store.commit('onLoading', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.isRequired {
  .innerTitle {
    padding-left: 18px;
    &:after {
      content: "*";
      position: absolute;
      top: 0;
      left: 8px;
      color: $color-red;
    }
  }
}
</style>
